import { styled, theme } from "@theme/stitches.config"
import { Link } from "gatsby"

export const CardWrapper = styled(Link, {
    color: theme.colors.white,
    cursor: "pointer",
    transition: "all 200ms ease",
    "&:hover": {
        transform: "translateY(-8px)",
        boxShadow: "0 10px 20px rgba(15, 23, 42, 0.2)"
    }
})

export const ImageWrapper = styled("div", {
    width: "100%",
    height: 352,
    "& img, & .gatsby-image-wrapper, * .gatsby-image-wrapper img": {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: "center top"
    },
    "@mdDown": {
        height: 240
    }
})

export const ContentWrapper = styled("div", {
    padding: 32,
    backgroundColor: "rgba(248, 250, 252, 0.15)",
    minHeight: 230,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "@lgDown": {
        minHeight: 0
    }
})

export const Description = styled("p", {
    m: 0,
    height: 75,
    display: "-webkit-box",
    "-webkit-line-clamp": 3,
    "-webkit-box-orient": "vertical",
    overflow: "hidden",
    "@lgDown": {
        mt: 16,
        mb: 24
    }
})

export const CardFooter = styled("div", {
    fontWeight: theme.fontWeights.regular,
    display: "flex",
    width: "100%"
})

export const CategoryIconWrapper = styled("span", {
    display: "block",
    ml: "auto",
    width: 24,
    height: "auto",
    maxHeight: 24,
    "& img, & .gatsby-image-wrapper, * .gatsby-image-wrapper img": {
        display: "block",
        width: "100%",
        height: "100%",
        objectFit: "contain !important"
    }
})
